import { render } from "./index.vue?vue&type=template&id=68ad866c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabLink/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68ad866c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68ad866c', __exports__)) {
    console.log('reload')
    api.reload('68ad866c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=68ad866c", () => {
    console.log('re-render')
    api.rerender('68ad866c', render)
  })

}


export default __exports__